import styled from 'styled-components';
import { FormGrid } from '../../../../style';

export const IdentificationGrid = styled(FormGrid)`
  margin-top: 16px;
`;
